var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m4.613 1.21.094.083L12 8.585l7.293-7.292a1 1 0 0 1 1.497 1.32l-.083.094L13.415 10l7.292 7.293a1 1 0 0 1-1.32 1.497l-.094-.083L12 11.415l-7.293 7.292a1 1 0 0 1-1.497-1.32l.083-.094L10.585 10 3.293 2.707a1 1 0 0 1 1.32-1.497",
    clipRule: "evenodd"
  })));
};
export { SvgCloseIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/src/Assets/icons/CloseIcon.svg";